(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var variantPicker = document.querySelector('[data-variant-picker]');
    var mainProductForm = document.querySelector('.sh-product-form');
    var stickyProductForm = document.querySelector('.sh-spb__form');
    var productJsonScript = document.querySelector('[data-product-json]');

    if (!variantPicker || !mainProductForm || !productJsonScript) return;

    var productData;

    try {
      productData = JSON.parse(productJsonScript.textContent);
    } catch (error) {
      console.error('Product JSON parse error:', error);
      return;
    }

    var product = productData.product || productData;

    if (!product || !Array.isArray(product.variants)) return;

    function getSelectedOptions() {
      var selectedOptions = [];

      [1, 2, 3].forEach(function (position) {
        var checkedRadio = variantPicker.querySelector(
          'input[type="radio"][data-option-position="' + position + '"]:checked'
        );

        var select = variantPicker.querySelector(
          'select[data-option-position="' + position + '"]'
        );

        if (checkedRadio) {
          selectedOptions[position - 1] = checkedRadio.value;
        } else if (select) {
          selectedOptions[position - 1] = select.value;
        }
      });

      return selectedOptions.filter(Boolean);
    }

    function findVariantByOptions(selectedOptions) {
      return product.variants.find(function (variant) {
        return selectedOptions.every(function (value, index) {
          var variantOption =
            variant.options && variant.options[index]
              ? variant.options[index]
              : variant['option' + (index + 1)];

          return String(variantOption).trim() === String(value).trim();
        });
      });
    }

    function getAddButton(form) {
      if (!form) return null;

      return (
        form.querySelector('[data-add-to-cart-button]') ||
        form.querySelector('[type="submit"][name="add"]') ||
        form.querySelector('button[type="submit"]')
      );
    }

    function updateButton(form, variant) {
      var button = getAddButton(form);

      if (!button) return;

      var buttonText = form.querySelector('[data-add-to-cart-text]') || button;

      if (!variant) {
        button.disabled = true;
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        buttonText.textContent = 'Unavailable';
        return;
      }

      if (variant.available) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        buttonText.textContent = 'Add To Cart';
      } else {
        button.disabled = true;
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        buttonText.textContent = 'Sold Out';
      }
    }

    function updateFormVariant(form, variant) {
      if (!form || !variant) return;

      var variantInput = form.querySelector('input[name="id"]');

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.setAttribute('value', variant.id);
      }

      updateButton(form, variant);
    }

    function updateActiveColorSwatches(input) {
      var group = input.closest('[data-color-swatches]');

      if (!group) return;

      group.querySelectorAll('.sh-product-color-swatch').forEach(function (swatch) {
        swatch.classList.remove('is-active');
      });

      var currentSwatch = input.closest('.sh-product-color-swatch');

      if (currentSwatch) {
        currentSwatch.classList.add('is-active');
      }
    }

    function updateSizeSelectFromButton(button) {
      var optionPosition = button.getAttribute('data-option-position');
      var value = button.getAttribute('data-size-value');

      if (!optionPosition || !value) return;

      var group = button.closest('[data-size-swatches]');
      var select = variantPicker.querySelector(
        'select[data-option-position="' + optionPosition + '"]'
      );

      if (!group || !select) return;

      select.value = value;

      group.querySelectorAll('.sh-size-swatch').forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');

      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function updateProductUrl(variant) {
      if (!variant) return;

      try {
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', newUrl.toString());
      } catch (error) {
        console.warn('Could not update variant URL.', error);
      }
    }

    function updateSampleButton(variant) {
      var sampleButton = document.querySelector('[data-order-sample-button]');

      if (!sampleButton || !variant) return;

      var samplePrice = variant.samplePrice || variant.sample_price;

      if (samplePrice) {
        sampleButton.textContent = 'Order Sample - $' + samplePrice;
        sampleButton.setAttribute('data-sample-price', samplePrice);
      }
    }

    function updateVariant() {
      var selectedOptions = getSelectedOptions();
      var matchedVariant = findVariantByOptions(selectedOptions);

      console.log('Selected Options:', selectedOptions);
      console.log('Matched Variant:', matchedVariant);

      updateButton(mainProductForm, matchedVariant);

      if (!matchedVariant) return;

      updateFormVariant(mainProductForm, matchedVariant);
      updateFormVariant(stickyProductForm, matchedVariant);

      updateProductUrl(matchedVariant);
      updateSampleButton(matchedVariant);

      document.dispatchEvent(
        new CustomEvent('sh:variant:change', {
          bubbles: true,
          detail: {
            variant: matchedVariant,
            selectedOptions: selectedOptions
          }
        })
      );
    }

    variantPicker.addEventListener('change', function (event) {
      var target = event.target;

      if (target.matches('.sh-product-color-swatch input[type="radio"]')) {
        updateActiveColorSwatches(target);
      }

      updateVariant();
    });

    variantPicker.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('.sh-size-swatch');

      if (!sizeButton) return;

      event.preventDefault();
      updateSizeSelectFromButton(sizeButton);

      setTimeout(updateVariant, 50);
    });

    mainProductForm.addEventListener('submit', function (event) {
      var variantInput = mainProductForm.querySelector('input[name="id"]');

      if (!variantInput || !variantInput.value) {
        event.preventDefault();
        alert('Please select a valid product option.');
        return;
      }

      var selectedVariant = product.variants.find(function (variant) {
        return String(variant.id) === String(variantInput.value);
      });

      if (!selectedVariant) {
        event.preventDefault();
        alert('Selected variant was not found. Please refresh the page and try again.');
        return;
      }

      if (!selectedVariant.available) {
        event.preventDefault();
        alert('This selected option is sold out in Shopify inventory.');
        return;
      }

      var button = getAddButton(mainProductForm);

      if (button) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
    });

    updateVariant();
  });
})();